import React from 'react';
import { SelectProps } from '@amzn/awsui-components-core';
import { Employee } from '../interfaces/interface';

/**
 * Checks if two Sets contain the same elements.
 * Uses content-based equality rather than reference equality.
 * @param a First Set to compare
 * @param b Second Set to compare
 * @returns true if both Sets contain the same elements, false otherwise
 */
export function areSetsEqual<T>(a: Set<T>, b: Set<T>): boolean {
  if (a.size !== b.size) return false;
  for (const item of a) {
    if (!b.has(item)) return false;
  }
  return true;
}

export const formatStateName = (stateName?: string): string => {
  if (!stateName) return '';
  return stateName.replace(/^USA-/, '');
};

export const formatEmployeeDetails = (employee: Employee): string => {
  const parts = [
    employee.department_name_current,
    employee.job_title_name,
    `${employee.location_city_name}, ${formatStateName(employee.location_state_name)}`,
    employee.job_level_name ? `L${employee.job_level_name}` : null
  ].filter(Boolean);

  return parts.join(' • ');
};

export interface EmployeeSelectOptionConfig {
  iconSize?: number;
  includeCountryPrefix?: boolean;
}
